import { render, staticRenderFns } from "./msw-dashboard.vue?vue&type=template&id=30365630&scoped=true&"
import script from "./msw-dashboard.vue?vue&type=script&lang=tsx&"
export * from "./msw-dashboard.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-dashboard.vue?vue&type=style&index=0&id=30365630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30365630",
  null
  
)

export default component.exports